export default __webpack_public_path__ + "static/media/Sub-Zero@2x.bc5165d5.png";